import React from "react";
import styled from "styled-components";
import { Divider } from "@material-ui/core";

import DayDetail from "./DayDetail";

const StyledPaper = styled.div`
	width: 600px;
	text-align: center;
	background: rgba(255, 255, 255, 0.25);
	box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
	backdrop-filter: blur(4px);
	-webkit-backdrop-filter: blur(4px);
	border-radius: 10px;
	border: 1px solid rgba(255, 255, 255, 0.18);
	h1 {
		font-size: 56px;
	}
	h3 {
		font-size: 50px;
	}
`;

const DivContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
`;
const LocationDetail = (props) => {
	return (
		<StyledPaper>
			<h1>{props.item.location.name}</h1>
			<p>{props.item.current.condition.text}</p>
			<h3>{props.item.current.temp_c} C</h3>
			<Divider />
			<DivContainer>
				{props.item.forecast.forecastday.map((element) => {
					return <DayDetail element={element} />;
				})}
			</DivContainer>
			<Divider />
			<div>
				<p>Feelslike: {props.item.current.feelslike_c} C</p>
				<p>Humidity:{props.item.current.humidity}%</p>
				<p>UV:{props.item.current.uv}</p>
				<p>
					Wind:{props.item.current.wind_kph}
					{props.item.current.wind_dir}
				</p>
			</div>
		</StyledPaper>
	);
};

export default LocationDetail;
